<template lang="pug">
  .assembly-instructions
    .row-wrap.col-layout(
      style="--above-header-height:0px; --checkout-banner-height:0px; --cookie-agree-height:0px; --mbn-banner-height:0px; font-family:'Roboto', Helvetica, Arial, sans-serif; font-size:1em; box-sizing:border-box; overflow:hidden; background-color:white; border:white;"
    )
      ProductInstructionsList(:entries="entries")
</template>
<script>
import { useProductStore } from '@/js/stores/productStore'

export default {
  name  : 'Instructions',
  props : {
    product: {
      type     : Object,
      required : false,
    },
  },
  setup() {
    const productStore = useProductStore()

    return { productStore }
  },
  computed: {
    products() {
      return this.productStore.products
    },

    items() {
      return [this.product.productId, ...this.product.childrenIds]
        .map(productId => this.products[productId])
        .filter(product => (product.attributes.instructions_gallery))
        .filter(item => item.attributes.instructions_gallery)
    },

    entries() {
      // Map to the expected entries format for ProductInstructionsList
      return this.items.map(item => ({
        sku       : item.sku,
        link      : item.attributes.instructions_gallery,
        thumbnail : { src: item.attributes.instructions_gallery },
      }))
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
